<template>
  <default-modal
    v-model="modalOpened"
    name="update-item-modal"
    :autofocus="$refs.itemsForm"
    :successHandler="handleUpdate"
    :title="$t('update_item')"
    width="sm"
  >
    <items-form slot="content" ref="itemsForm" :item="item"></items-form>
  </default-modal>
</template>

<script>
  import DefaultModal from 'components/Modal/DefaultModal.vue'
  import { ItemsClient } from 'src/api/Items'
  import ItemsForm from './ItemsForm.vue'
  import changeCase from 'change-case-object'

  export default {
    data () {
      return {
        modalOpened: false,
        item: {}
      }
    },

    methods: {
      handleUpdate () {
        this.$refs.itemsForm.update()
          .then(success => {
            if (!success) {
              return
            }

            this.modalOpened = false
            this.$refs.itemsForm.reset()
          })
      },

      open (id) {
        new ItemsClient()
          .get(id)
          .then(response => {
            this.item = changeCase.camel(response.data.data[0])
            this.modalOpened = true
          })
      }
    },

    components: {
      ItemsForm,
      DefaultModal
    }
  }
</script>
